export default __webpack_public_path__ + "static/media/logo-bg.d6d8504b.png";